import {
  collection,
  query,
  getDocs,
  onSnapshot,
  where,
  addDoc,
  updateDoc,
  doc,
  setDoc,
  deleteDoc,
  orderBy,
} from 'firebase/firestore';
import { LANGUAGES } from './constants';
import { db, auth } from './firebase';

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const onCollectionChange = (table, setSnapshot) => {
  const q = query(collection(db, table));
  onSnapshot(q, querySnapshot => {
    setSnapshot(querySnapshot);
  });
};

const queryByTable = (tableName, whereCondition, orderByField) => {
  if (whereCondition) {
    if (orderByField) {
      return query(
        collection(db, tableName),
        whereCondition,
        orderBy(orderByField),
      );
    }
    return query(collection(db, tableName), whereCondition);
  }
  if (orderByField) {
    return query(collection(db, tableName), orderBy(orderByField));
  }
  return query(collection(db, tableName));
};

export const fetchByTable = async params => {
  const {
    tableName,
    whereCondition,
    setLoading = () => {},
    orderByField = null,
  } = params;
  setLoading(true);
  const querySnapshot = await getDocs(
    queryByTable(tableName, whereCondition, orderByField),
  );
  const col = [];
  querySnapshot.forEach(d => {
    col.push({ ...d.data(), id: d.id });
  });
  setLoading(false);
  return col;
};

export const addDataToTable = async params => {
  const { tableName, data, setLoading = () => {} } = params;
  setLoading(true);
  const res = await addDoc(collection(db, tableName), data);
  setLoading(false);
  return res;
};

export const addDataToTableWithCustomId = async params => {
  const { tableName, id, data, setLoading = () => {} } = params;
  setLoading(true);
  const res = await setDoc(doc(db, tableName, id), data);
  setLoading(false);
  return res;
};

export const updateDataById = async params => {
  const { id, tableName, data, setLoading = () => {} } = params;
  setLoading(true);
  const docRef = doc(db, tableName, id);
  await updateDoc(docRef, data);
  setLoading(false);
  return true;
};

export const deleteDocById = async params => {
  const { id, tableName, setLoading = () => {} } = params;
  setLoading(true);
  const docRef = doc(db, tableName, id);
  await deleteDoc(docRef);
  setLoading(false);
  return true;
};

export const deleteDocsByWhere = async params => {
  const { id, tableName, setLoading = () => {} } = params;
  setLoading(true);
  const docRef = doc(db, tableName, id);
  await deleteDoc(docRef);
  setLoading(false);
  return true;
};

const getLocaleLangByUserLanguage = userLanguage => {
  let lang = 'es-ES';
  if (userLanguage === LANGUAGES.SPANISH) {
    lang = 'es-ES';
  }
  if (userLanguage === LANGUAGES.ENGLISH) {
    lang = 'en-US';
  }
  if (userLanguage === LANGUAGES.ARABIC) {
    lang = 'ar';
  }
  return lang;
};

export const getDateFromTimestamp = timestamp =>
  `${new Date(timestamp?.toDate()).toLocaleDateString()} ${new Date(
    timestamp?.toDate(),
  ).toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
  })}`;

const capitalizeFirstLetter = string =>
  string.charAt(0).toUpperCase() + string.slice(1);

export const getShiftDateFromTimestamp = (timestamp, language) => {
  const date = new Date(timestamp?.toDate());
  const dayOfWeek = capitalizeFirstLetter(
    date.toLocaleDateString(getLocaleLangByUserLanguage(language), {
      weekday: 'long',
    }),
  );
  const dayMonth = date.toLocaleDateString(
    getLocaleLangByUserLanguage(language),
    { day: 'numeric', month: 'numeric' },
  );
  const timePart = date.toLocaleTimeString([], {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
  return `${dayOfWeek} ${dayMonth} ${timePart}`;
};

export const getLeagueDateFromTimestamp = (timestamp, language) => {
  const date = new Date(timestamp?.toDate());
  const dayOfWeek = capitalizeFirstLetter(
    date.toLocaleDateString(getLocaleLangByUserLanguage(language), {
      weekday: 'long',
    }),
  );
  const dayMonth = date.toLocaleDateString(
    getLocaleLangByUserLanguage(language),
    { day: 'numeric', month: 'numeric' },
  );
  return `${dayOfWeek} ${dayMonth}`;
};

export const getTimerByDate = date => {
  if (!date) {
    return null;
  }
  const timePart = date.toLocaleTimeString([], {
    minute: '2-digit',
    second: '2-digit',
  });
  return `${timePart}''`;
};

export const copyText = (text, message) => {
  navigator.clipboard.writeText(text).then(
    () => message.success(`${text} copiado con exito`),
    () => err => message.error(err),
  );
};
